<template>
  <div class="relative">
    <div
      class="absolute z-20 inset-0 overflow-hidden"
      :class="toolbarDrawer.isOpen ? 'pointer-events-auto' : 'pointer-events-none'"
    >
      <pdl-drawer
        bound
        placement="left"
        qaid="project-one-toolbar-drawer"
        size="25rem"
        :show-close="true"
        :is-open="toolbarDrawer.isOpen"
        @close="onDrawerClose"
      >
        <component :is="toolbarDrawer.currentDrawerTab" slot="content" :base-properties="baseProperties" />
      </pdl-drawer>
    </div>

    <slot name="content" />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {PdlDrawer} from '@pedal/pdl-drawer';
import ProjectOneToolbarPrintSellSheet from '@/projectOne/components/toolbar/surfaces/ProjectOneToolbarPrintSellSheet';
import ProjectOneToolbarPriceLeadTime from '@/projectOne/components/toolbar/surfaces/ProjectOneToolbarPriceLeadTime';
import ProjectOneToolbarCustomerInfo from '@/projectOne/components/toolbar/surfaces/ProjectOneToolbarCustomerInfo';
import ProjectOneToolbarSizing from '@/projectOne/components/toolbar/surfaces/ProjectOneToolbarSizing';
import ProjectOneToolbarSpec from '@/projectOne/components/toolbar/surfaces/ProjectOneToolbarSpec';

export default {
  components: {
    PdlDrawer,
    ProjectOneToolbarPrintSellSheet,
    ProjectOneToolbarPriceLeadTime,
    ProjectOneToolbarCustomerInfo,
    ProjectOneToolbarSizing,
    ProjectOneToolbarSpec,
  },

  data() {
    return {
      drawerOpen: false,
      currentDrawerTab: null,
    };
  },

  computed: {
    ...mapState('projectOne', ['toolbarDrawer']),
  },

  methods: {
    onDrawerClose() {
      this.setDrawerCurrentTabAndOpenState(null);
    },

    ...mapActions('projectOne', ['setDrawerCurrentTabAndOpenState']),
  },
};
</script>
